// AI-виджет inline — извлечено из HTML

(function(){
  var hist=[], profile={}, loading=false, open=false, leadSent=false;

  // ai-alisa-revive A.1 (2026-05-30): стабильный per-браузер session_id для
  // backend per-session rate-limit (HeroScopeGuard). Персистим в localStorage
  // чтобы id переживал перезагрузки (один посетитель = один bucket). Graceful
  // fallback на in-memory id если localStorage недоступен (приватный режим/iframe).
  function genSessionId(){
    try{
      if(typeof crypto!=='undefined' && typeof crypto.randomUUID==='function') return crypto.randomUUID();
    }catch(_e){/* no-op */}
    return 'sid-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);
  }
  var sessionId;
  try{
    if(typeof window.localStorage!=='undefined'){
      sessionId=window.localStorage.getItem('aiAlisaSid');
      if(!sessionId){ sessionId=genSessionId(); window.localStorage.setItem('aiAlisaSid',sessionId); }
    }
  }catch(_e){/* SecurityError в iframe/приватном режиме — fallback ниже */}
  if(!sessionId) sessionId=genSessionId();

  // В-15 (02.09.2026): город и данные карточки приходят ТОЛЬКО от сервера —
  // data-атрибуты контейнера #aiW (их заполняет footer.php из данных карточки ЖК,
  // класс AiWidgetLead). ⛔ ?city= и window.currentCity убраны НАВСЕГДА: на
  // ЧПУ-адресах ?city= нет, currentCity не выставлял никто — и запасная ветка
  // «в Курске» срабатывала почти всегда (1 456 сниппетов, замер 23.08).
  // Нет атрибутов → города нет: молчим о городе, чужой не называем.
  var aiwRoot = document.getElementById('aiW');
  var pageCity = (aiwRoot && aiwRoot.getAttribute('data-ai-city')) || '';
  var pageCityPrep = (aiwRoot && aiwRoot.getAttribute('data-ai-city-prep')) || '';
  if (pageCity) profile.city = pageCity;

  // A-1 (03.09.2026, слово владельца «пусть на каждом ЖК свой текст с указанием
  // ЖК; в каждом городе свой город или область»). Оба значения ГОТОВЫМИ приходят
  // от AiWidgetLead:
  //   data-ai-place — обстоятельство места целиком: «в ЖК «Грейд» в Краснодаре»,
  //     «в комплексе «Квартал Герцена» в Москве», «в ЖК «Южная Битца» в посёлке
  //     Битца под Москвой». ⛔ Скрипт его НЕ СОБИРАЕТ и НЕ СКЛОНЯЕТ: выбор между
  //     «в ЖК «…»» и «в комплексе «…»» и падеж места — работа сервера (В-15,
  //     Курск-урок). Здесь строка только печатается.
  //   data-ai-noun — ГОТОВОЕ слово в винительном: «квартиру», «апартаменты» или
  //     «квартиру или апартаменты». ⛔ Правило проекта «апартаменты ≠ квартиры»
  //     (ось апартаментов 23.08): класс жилья решает домен на сервере, скрипт
  //     не сравнивает флагов и не держит списка. Атрибута нет (старый кэш) —
  //     «квартиру», как было до правки.
  //   data-ai-cert — уместен ли на этой странице сертификат приграничья.
  var pageIsCard = !!(aiwRoot && aiwRoot.getAttribute('data-ai-card') === '1');
  var pageJkPlace = (aiwRoot && aiwRoot.getAttribute('data-ai-place')) || '';
  var pageJkNoun = (aiwRoot && aiwRoot.getAttribute('data-ai-noun')) || 'квартиру';

  // ⛔ Сертификат приграничья — АДРЕСНАЯ льгота (Курск, Белгород), и до 03.09.2026
  // приветствие предлагало её на КАЖДОЙ карточке сайта. Список городов живёт
  // в CertificateProgram на сервере; скрипт его не копирует, а читает вердикт.
  // На карточке без атрибута (страница из кэша, снятого до выката) — считаем «нет»:
  // промолчать про чужую льготу дешевле, чем предложить её тому, кому не положена.
  // На НЕ-карточках (общие страницы, /sertifikat.php) поведение прежнее.
  var certRelevant = pageIsCard ? (aiwRoot.getAttribute('data-ai-cert') === '1') : true;

  // B.1: SSE-стриминг ответа Алисы. PHP проставляет data-ai-stream="1" на #aiW
  // только когда AI_STREAM_ENABLED И ASSISTANT_SCOPE_ENABLED включены на проде.
  // При "0" / отсутствии флага / без ReadableStream → non-stream JSON-путь (B.2).
  function streamEnabled(){
    try{
      var w=document.getElementById('aiW');
      if(!w||w.getAttribute('data-ai-stream')!=='1')return false;
      // ReadableStream-чтение fetch.body нужно для SSE-разбора.
      return typeof ReadableStream!=='undefined' && typeof TextDecoder!=='undefined';
    }catch(_e){return false;}
  }

  // SEO P0.1 (2026-08-23) + В-15 (02.09.2026). Раньше запасной веткой здесь
  // стояло ' в Курске и других городах' — и она срабатывала ПОЧТИ ВСЕГДА
  // (замер 23.08: 1 456 из 1 470 проиндексированных страниц обещали Курск).
  // Теперь падеж города приходит ГОТОВЫМ от сервера (data-ai-city-prep — тот же
  // $jkCityPrep, что в title и H1 карточки): словаря склонений в скрипте больше
  // нет, склоняться самому не из чего. Не знаем город — молчим о городе.
  var cityGreeting = pageCityPrep ? ' в ' + pageCityPrep : '';

  // Вопрос про адресную льготу — отдельной строкой, потому что задаётся он
  // не всем: только там, где сертификат приграничья действительно работает.
  var CERT_QUESTION = 'Что вас интересует — покупка для себя или по сертификату приграничья?';

  // Единственный источник текста приветствия. Раньше литерал стоял в ДВУХ местах
  // (старт виджета и «Новый диалог») — правка одного оставляла второй жить.
  //
  // A-1: на карточке ЖК вторая фраза называет ИМЕННО ЭТОТ дом и его место
  // (готовая строка сервера) и перечисляет, чем чат тут полезен. Нет места —
  // прежняя общая фраза; ⛔ полфразы из догадки не бывает.
  function greetingText(){
    var about = pageJkPlace
      ? ' Помогу выбрать ' + pageJkNoun + ' ' + pageJkPlace
        + ': расскажу про цены, сроки сдачи и планировки, посчитаю ипотеку и помогу забронировать.'
      : ' Помогу подобрать квартиру в новостройке' + cityGreeting + '.';
    return 'Здравствуйте! 👋 Я Алиса, AI-консультант «БРОНИДОМ».' + about
      + (certRelevant ? '\n\n' + CERT_QUESTION : '');
  }

  // ai-bot-24-7 (2026-06-30): персист диалога. Раньше hist/profile жили только
  // в памяти → перезагрузка страницы = диалог начинался заново (теряли контекст
  // и уже собранный профиль). Теперь сохраняем ленту в localStorage с TTL и
  // восстанавливаем под приветствием. PDn: текст диалога ок, но СТРУКТУРНЫЙ
  // profile.phone в storage НЕ кладём (см. persistChat). Восстановление — сразу
  // после greeting, чтобы порядок был «приветствие → прошлый диалог».
  var CHAT_STORE_KEY='aiAlisaChat';
  var CHAT_TTL_MS=45*60*1000;   // 45 мин — разумное окно «продолжить разговор»

  // SEO P0.1 (2026-08-23), часть А. Приветствие и восстановление диалога больше
  // НЕ выполняются при загрузке страницы — только при первом открытии чата.
  // Причина: Яндекс отрисовывает страницу как браузер и берёт текст из готового
  // DOM. Приветствие лежало в #aiBody на КАЖДОЙ странице сайта и подменяло собой
  // description в сниппете. ⛔ display:none от этого НЕ спасает — контейнер #aiW
  // скрыт стилями, и текст всё равно попадал в выдачу (замерено 23.08).
  // Чего нет в DOM — того поиск взять не может.
  var chatPainted=false;
  function ensureChatPainted(){
    if(chatPainted)return;
    chatPainted=true;
    addMsg('b',greetingText());
    restoreChat();
  }

  // SEO В-4 (28.08.2026). Часть Б той же поломки, что и приветствие выше: сервер
  // отдавал ВСЮ оболочку окна — «Алиса — AI-консультант», «Онлайн», плашку
  // «✅ Заявка отправлена! Агент позвонит вам…», подписи быстрых кнопок и
  // placeholder поля ввода. Приветствие мы убрали 23.08, а служебные подписи
  // остались лежать в HTML КАЖДОЙ страницы (замер 28.08 на карточке Роттердама:
  // 4 вхождения «Онлайн», по одному «Алиса», «AI-консультант», «Заявка
  // отправлена», «Агент позвонит»). Робот исполняет наш JS и читает готовый DOM,
  // поэтому «спрятать стилями» здесь не работает — работает «не рисовать до
  // действия человека». Кнопок робот не нажимает.
  //
  // ⛔ Оболочка строится РОВНО ОДИН РАЗ и до любого обращения к её узлам.
  //    Точек входа три: открытие чата (aiToggle), сброс диалога (aiClearChat) и
  //    восстановление после ошибки — все зовут ensureShell() первой строкой.
  //    Идемпотентность держится не флагом, а фактом: есть #aiBody — значит уже
  //    построено. Флаг разошёлся бы с DOM при повторном исполнении скрипта.
  var shellBound=false;
  function el(tag,cls,id,text){
    var n=document.createElement(tag);
    if(cls)n.className=cls;
    if(id)n.id=id;
    if(text)n.textContent=text;
    return n;
  }
  function ensureShell(){
    var w=document.getElementById('aiW');
    if(!w)return null;
    // В-15: серверная фраза под выдачу (#aiSeoLead) живёт в контейнере ради
    // робота. Человек открыл чат — фраза уступает место оболочке; робот кнопок
    // не жмёт и видит её всегда.
    var seoLead=document.getElementById('aiSeoLead');
    if(seoLead)seoLead.remove();
    if(document.getElementById('aiBody')){ bindShell(); return w; }

    var hd=el('div','ai-hd');
    hd.appendChild(el('div','ai-av',null,'AI'));
    var info=el('div','info');
    info.appendChild(el('div','nm',null,'Алиса — AI-консультант'));
    info.appendChild(el('div','st',null,'Онлайн'));
    hd.appendChild(info);
    var bNew=el('button','cls','aiNew','🗑');
    bNew.type='button';bNew.title='Новый диалог';bNew.setAttribute('aria-label','Новый диалог');
    hd.appendChild(bNew);
    var bClose=el('button','cls','aiClose','✕');
    bClose.type='button';bClose.title='Свернуть чат';bClose.setAttribute('aria-label','Свернуть чат');
    hd.appendChild(bClose);
    w.appendChild(hd);

    w.appendChild(el('div','ai-pbar','aiPbar'));
    w.appendChild(el('div','ai-body','aiBody'));

    var lead=el('div','ai-lead','aiLead');
    lead.appendChild(el('div','msg',null,'✅ Заявка отправлена! Агент позвонит вам в ближайшее время.'));
    w.appendChild(lead);

    var q=el('div','ai-q','aiQ');
    // A-1: кнопка «Сертификат» — по тому же правилу, что и вопрос в приветствии.
    // ⛔ Сам сценарий чата не трогаем: подпись и текст запроса прежние, и слово
    // «сертификат» по-прежнему ловит AiFactAnswer ДО модели — меняется только
    // ГДЕ мы эту кнопку предлагаем.
    var qk=[['Ищу квартиру в новостройке','🏠 Подобрать квартиру']];
    if(certRelevant)qk.push(['Расскажи про сертификат приграничья','📜 Сертификат']);
    qk.push(['Какие ставки по ипотеке?','🏦 Ипотека']);
    qk.forEach(function(pair){
      var b=el('button',null,null,pair[1]);
      b.type='button';
      b.setAttribute('data-aiqk',pair[0]);
      q.appendChild(b);
    });
    w.appendChild(q);

    var inp=el('div','ai-inp');
    var field=document.createElement('input');
    field.id='aiIn';field.type='text';field.placeholder='Задайте вопрос...';
    field.setAttribute('aria-label','Сообщение чат-консультанту');
    inp.appendChild(field);
    var send=el('button',null,'aiBtn','➤');
    send.type='button';send.setAttribute('aria-label','Отправить');
    inp.appendChild(send);
    w.appendChild(inp);

    bindShell();
    return w;
  }

  // Обработчики оболочки. Вешаются ОДИН раз, сразу после постройки: до неё
  // вешать не на что (узлов нет), а второй раз — значило бы два вызова на клик.
  function bindShell(){
    if(shellBound)return;
    shellBound=true;
    var closeBtn=document.getElementById('aiClose');
    if(closeBtn) closeBtn.addEventListener('click',window.aiToggle);
    var newBtn=document.getElementById('aiNew');
    if(newBtn) newBtn.addEventListener('click',window.aiClearChat);
    document.querySelectorAll('[data-aiqk]').forEach(function(b){
      b.addEventListener('click',function(){window.aiQk(b.dataset.aiqk);});
    });
    var aiIn=document.getElementById('aiIn');
    if(aiIn){
      aiIn.addEventListener('keydown',function(e){if(e.key==='Enter')window.aiSend();});
      // Фокус → клавиатура открывается; visualViewport resize обычно покрывает
      // это, но дублируем отложенным пересчётом на случай задержки анимации.
      aiIn.addEventListener('focus',function(){
        bindViewport();
        updateViewportVars();
        setTimeout(updateViewportVars,250);
      });
    }
    var aiBtn=document.getElementById('aiBtn');
    if(aiBtn) aiBtn.addEventListener('click',window.aiSend);
  }

  // ai-alisa-mobile H1 (2026-06-29): окно чата position:fixed якорится к
  // layout viewport. На мобиле при открытой экранной клавиатуре layout
  // viewport НЕ ужимается (клавиатура перекрывает visual viewport) → поле
  // ввода + кнопка «отправить» уезжают ПОД клавиатуру и не видны. Считаем
  // высоту клавиатуры через visualViewport и держим окно над ней через
  // CSS-переменные --ai-kb (высота клавиатуры) и --ai-vvh (видимая высота).
  function updateViewportVars(){
    try{
      var w=document.getElementById('aiW');
      if(!w)return;
      var vv=window.visualViewport;
      if(!vv){
        w.style.removeProperty('--ai-kb');
        w.style.removeProperty('--ai-vvh');
        return;
      }
      var kb=Math.max(0, Math.round((window.innerHeight||0) - vv.height - (vv.offsetTop||0)));
      w.style.setProperty('--ai-kb', kb+'px');
      w.style.setProperty('--ai-vvh', Math.round(vv.height)+'px');
    }catch(_e){/* no-op */}
  }
  var vvBound=false;
  function bindViewport(){
    if(vvBound)return;
    try{
      if(typeof window.visualViewport==='undefined'||!window.visualViewport)return;
      window.visualViewport.addEventListener('resize',updateViewportVars);
      window.visualViewport.addEventListener('scroll',updateViewportVars);
      vvBound=true;
    }catch(_e){/* no-op */}
  }

  window.aiToggle=function(mode){
    open=!open;
    // ⛔ SEO В-4: оболочка окна строится ровно здесь — на первом открытии.
    //    Порядок обязателен: сначала узлы, потом лента внутри них.
    ensureShell();
    // ⛔ SEO P0.1: рисуем ленту ровно здесь — на первом открытии, не при загрузке.
    if(open)ensureChatPainted();
    document.getElementById('aiW').classList.toggle('open',open);
    document.getElementById('aiFab').classList.toggle('open',open);
    document.getElementById('aiFabI').textContent=open?'✕':'💬';
    if(open){
      bindViewport();
      updateViewportVars();
      scrollBody();   // лента отрисована в скрытом окне — доводим до низа после показа
      // В-15: при АВТО-открытии поле не фокусируем — фокус на мобиле поднимает
      // клавиатуру, и «закрыть одним касанием» превращается в два. Клик человека
      // приходит с Event первым аргументом, авто-путь зовёт aiToggle('auto').
      if(mode!=='auto')document.getElementById('aiIn').focus();
    }else{
      // Окно закрыто — сбрасываем клавиатурный сдвиг (чистое исходное положение).
      var w=document.getElementById('aiW');
      if(w){ try{ w.style.setProperty('--ai-kb','0px'); }catch(_e){/* no-op */} }
      // В-15: одно касание «закрыть» — и авто-открытие в этой сессии больше не
      // случится. Флаг ставится на ЛЮБОЕ закрытие (авто или ручное): человек,
      // закрывший чат, своё решение уже сообщил.
      try{if(window.sessionStorage)window.sessionStorage.setItem('aiAutoOpenDone','1');}catch(_e){/* no-op */}
    }
  };

  window.aiQk=function(t){
    document.getElementById('aiIn').value=t;
    window.aiSend();
    document.getElementById('aiQ').style.display='none';
  };

  window.aiSend=async function(){
    if(loading||leadSent)return;
    var inp=document.getElementById('aiIn'),msg=inp.value.trim();
    if(!msg)return;
    inp.value='';
    addMsg('u',msg);
    hist.push({role:'user',content:msg});
    if(hist.length>50) hist=hist.slice(-50);
    persistChat();   // вопрос сохраняем сразу — переживёт закрытие/обрыв ответа

    loading=true;
    document.getElementById('aiBtn').disabled=true;

    // B.1: если стрим включён на проде — пробуем SSE; при любой ошибке/недоступности
    // SSE-пути падаем на проверенный non-stream JSON-путь (graceful, виджет не ломается).
    if(streamEnabled()){
      var streamed=await sendStream(msg);
      if(streamed){
        loading=false;
        document.getElementById('aiBtn').disabled=false;
        persistChat();   // SSE-путь: ответ отстримлен → сохраняем диалог
        return;
      }
      // streamed===false → SSE недоступен/ошибка → fallthrough на JSON-путь ниже.
    }

    await sendJson(msg);

    loading=false;
    document.getElementById('aiBtn').disabled=false;
    persistChat();   // ответ Алисы + обновлённый профиль/лид — в storage
  };

  // ── Non-stream JSON-путь (B.2, без изменений) ────────────────────────────
  async function sendJson(msg){
    var typ=addMsg('b t','Подбираю информацию...');

    // B.2: таймаут запроса через AbortController (~28с). yandexgpt с tool-loop
    // иногда долго думает; без таймаута typing-индикатор висел бы вечно. По abort
    // → catch → typing убирается + дружелюбное сообщение, повторная отправка ОК
    // (loading сбрасывается в вызывающем aiSend).
    var ctrl=(typeof AbortController!=='undefined')?new AbortController():null;
    var timedOut=false;
    var to=setTimeout(function(){timedOut=true;if(ctrl)ctrl.abort();},28000);

    try{
      // Абсолютный путь: на SEO-роутах /novostroyki/{city}/ относительный
      // 'ai_chat.php' резолвится в /novostroyki/{city}/ai_chat.php → 404
      // (Primary script unknown). '/ai_chat.php' всегда бьёт в корневой роутер.
      var res=await fetch('/ai_chat.php',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        credentials:'include',
        signal:ctrl?ctrl.signal:undefined,
        body:JSON.stringify({
          message:msg,
          history:hist.slice(-10),
          city:profile.city||'',
          profile:profile,
          scope:'assistant',
          session_id:sessionId
        })
      });
      var data=await res.json();
      typ.remove();

      if(data.ok&&data.reply){
        addMsg('b',data.reply);
        hist.push({role:'assistant',content:data.reply});

        // B.2: мини-карточки ЖК под текстом (если backend вернул cards).
        if(data.cards&&data.cards.length){
          renderCards(data.cards);
        }

        // Обновляем профиль
        if(data.profile){
          profile=data.profile;
          updateProfileBar();
        }

        // Лид отправлен в CRM
        if(data.lead){
          showLeadSuccess(data.lead);
        }
      }else{
        addMsg('b',data.error||'Ошибка. Позвоните: 8 (919) 170-19-18');
      }
    }catch(e){
      typ.remove();
      if(timedOut||(e&&e.name==='AbortError')){
        addMsg('b','⌛ Не дождался ответа, попробуйте ещё раз или позвоните: 8 (919) 170-19-18');
      }else{
        addMsg('b','⚠️ Не удалось связаться с сервером. Позвоните: 8 (919) 170-19-18');
      }
    }finally{
      clearTimeout(to);
    }
  }

  // ── SSE-стрим (B.1) ──────────────────────────────────────────────────────
  // Возвращает true если ответ успешно отстримлен (хотя бы финал получен),
  // false если SSE недоступен / endpoint вернул error → вызывающий уйдёт на JSON.
  // События: status (typing-текст), token (дописываем в bubble), done (cards),
  // error (флаг OFF / scope недоступен → fallback на non-stream).
  async function sendStream(msg){
    var typ=addMsg('b t','Подбираю информацию...');
    var bubble=null;       // bubble финального ответа (создаём на первом token)
    var acc='';            // накопленный текст (для history + проверки непустоты)
    var gotError=false;    // endpoint прислал type:error → fallback
    var doneCards=null;

    var ctrl=(typeof AbortController!=='undefined')?new AbortController():null;
    var timedOut=false;
    var to=setTimeout(function(){timedOut=true;if(ctrl)ctrl.abort();},28000);

    try{
      // Абсолютный путь (см. sendJson): относительный 'ai_chat_stream.php'
      // на /novostroyki/{city}/ давал 404 → SSE-стрим молча падал в JSON-путь
      // (который сам тоже 404-ил). '/ai_chat_stream.php' = корневой стрим-роутер.
      var res=await fetch('/ai_chat_stream.php',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        credentials:'include',
        signal:ctrl?ctrl.signal:undefined,
        body:JSON.stringify({
          message:msg,
          history:hist.slice(-10),
          city:profile.city||'',
          profile:profile,
          scope:'assistant',
          session_id:sessionId,
          stream:1
        })
      });
      if(!res.ok||!res.body){ typ.remove(); clearTimeout(to); return false; }

      var reader=res.body.getReader();
      var decoder=new TextDecoder('utf-8');
      var buf='';
      // Читаем поток, парсим SSE-кадры (разделены \n\n), каждый кадр = data: <json>.
      while(true){
        var chunk=await reader.read();
        if(chunk.done)break;
        buf+=decoder.decode(chunk.value,{stream:true});
        var idx;
        while((idx=buf.indexOf('\n\n'))!==-1){
          var frame=buf.slice(0,idx);
          buf=buf.slice(idx+2);
          var ev=parseSseFrame(frame);
          if(!ev)continue;
          if(ev.type==='error'){ gotError=true; }
          else if(ev.type==='status'){ if(typ)typ.textContent=String(ev.text||'Подбираю информацию...'); }
          else if(ev.type==='token'){
            if(!bubble){ if(typ){typ.remove();typ=null;} bubble=addMsg('b',''); }
            acc+=String(ev.text||'');
            bubble.textContent=acc;
            scrollBody();
          }
          else if(ev.type==='done'){
            if(ev.cards&&ev.cards.length)doneCards=ev.cards;
          }
        }
      }
      if(typ)typ.remove();

      if(gotError&&!acc){ clearTimeout(to); return false; } // флаг OFF → JSON-путь

      if(acc){
        hist.push({role:'assistant',content:acc});
        if(doneCards)renderCards(doneCards);
        clearTimeout(to);
        return true;
      }
      // Пустой стрим без явной ошибки — деградируем на JSON-путь.
      clearTimeout(to);
      return false;
    }catch(e){
      if(typ)typ.remove();
      if(bubble&&acc){
        // Частичный ответ уже показан — не дёргаем JSON повторно (избежим дубля).
        hist.push({role:'assistant',content:acc});
        clearTimeout(to);
        return true;
      }
      clearTimeout(to);
      // Сети нет / abort до первого токена → пусть JSON-путь покажет сообщение.
      return false;
    }
  }

  // Распарсить один SSE-кадр (строки, среди которых data: <json>). Прочие — игнор.
  function parseSseFrame(frame){
    var lines=frame.split('\n');
    for(var i=0;i<lines.length;i++){
      var line=lines[i];
      if(line.indexOf('data:')!==0)continue;
      var json=line.slice(5).trim();
      if(!json||json==='[DONE]')continue;
      try{return JSON.parse(json);}catch(_e){return null;}
    }
    return null;
  }

  function scrollBody(){
    var body=document.getElementById('aiBody');
    if(body)body.scrollTop=body.scrollHeight;
  }

  // B.2: рендер мини-карточек ЖК. CSP-safe — addEventListener (НЕ inline onclick),
  // textContent для названий/цен (XSS-safe, имя ЖК из БД), url — открываем через
  // location.assign по клику (НЕ innerHTML href, чтоб не доверять url слепо;
  // допускаем только same-origin относительные / абсолютные на свой домен).
  function renderCards(cards){
    var body=document.getElementById('aiBody');
    if(!body)return;
    var wrap=document.createElement('div');
    wrap.className='ai-cards';
    cards.forEach(function(c){
      if(!c||!c.name)return;
      var card=document.createElement('div');
      card.className='ai-card';

      var nm=document.createElement('div');
      nm.className='ai-card-nm';
      nm.textContent=String(c.name);
      card.appendChild(nm);

      if(c.price_from!=null&&!isNaN(c.price_from)){
        var pr=document.createElement('div');
        pr.className='ai-card-pr';
        pr.textContent='от '+formatRub(c.price_from)+' ₽';
        card.appendChild(pr);
      }

      var url=safeJkUrl(c.url,c.id);
      if(url){
        var lnk=document.createElement('a');
        lnk.className='ai-card-lnk';
        lnk.textContent='Подробнее →';
        lnk.href=url;
        lnk.target='_blank';
        lnk.rel='noopener';
        card.appendChild(lnk);
      }

      wrap.appendChild(card);
    });
    if(wrap.children.length){
      body.appendChild(wrap);
      body.scrollTop=body.scrollHeight;
    }
  }

  // Разбивка цены по разрядам (12345678 → «12 345 678»). Без локали — пробел-сепаратор.
  function formatRub(n){
    var s=String(Math.round(Number(n)));
    return s.replace(/\B(?=(\d{3})+(?!\d))/g,' ');
  }

  // Доверяем только относительным /jk.php?id= или абсолютным на тот же origin.
  // Чужой/мусорный url → строим безопасную ссылку из id (fallback). Anti open-redirect.
  function safeJkUrl(url,id){
    var u=(typeof url==='string')?url.trim():'';
    if(u){
      if(u.charAt(0)==='/'&&u.indexOf('//')!==0)return u;
      try{
        var parsed=new URL(u,location.origin);
        if(parsed.origin===location.origin)return parsed.href;
      }catch(_e){/* невалидный url → fallback ниже */}
    }
    var nid=parseInt(id,10);
    return (nid>0)?jkHref({id:nid}):'';
  }

  function addMsg(cls,text){
    var body=document.getElementById('aiBody');
    var div=document.createElement('div');
    div.className='ai-m '+cls;
    div.textContent=text;
    body.appendChild(div);
    body.scrollTop=body.scrollHeight;
    return div;
  }

  // ── Персист диалога (ai-bot-24-7) ────────────────────────────────────────
  // Сохраняем последние 50 реплик + профиль (БЕЗ сырого телефона) + флаг лида.
  // try/catch: приватный режим / quota / iframe SecurityError → тихий no-op.
  function persistChat(){
    try{
      if(typeof window.localStorage==='undefined')return;
      var safeProfile={};
      for(var k in profile){
        if(!Object.prototype.hasOwnProperty.call(profile,k))continue;
        if(k==='phone')continue;            // ПДн — в storage не кладём
        safeProfile[k]=profile[k];
      }
      var payload={v:1,ts:Date.now(),hist:hist.slice(-50),profile:safeProfile,leadSent:leadSent};
      window.localStorage.setItem(CHAT_STORE_KEY,JSON.stringify(payload));
    }catch(_e){/* no-op */}
  }

  // Восстановить диалог из localStorage если он свежий (в пределах TTL).
  // Рендерит сохранённые реплики под приветствием, поднимает profile + бар,
  // прячет quick-кнопки (юзер уже общался). Битый/протухший payload → чистим.
  function restoreChat(){
    try{
      if(typeof window.localStorage==='undefined')return false;
      var raw=window.localStorage.getItem(CHAT_STORE_KEY);
      if(!raw)return false;
      var data=JSON.parse(raw);
      if(!data||data.v!==1||typeof data.ts!=='number'||!Array.isArray(data.hist)){
        window.localStorage.removeItem(CHAT_STORE_KEY);return false;
      }
      if(Date.now()-data.ts>CHAT_TTL_MS){            // протух → начинаем заново
        window.localStorage.removeItem(CHAT_STORE_KEY);return false;
      }
      if(!data.hist.length)return false;
      if(data.profile&&typeof data.profile==='object'){
        for(var k in data.profile){
          if(Object.prototype.hasOwnProperty.call(data.profile,k))profile[k]=data.profile[k];
        }
      }
      data.hist.forEach(function(m){
        if(!m||typeof m.content!=='string')return;
        addMsg(m.role==='user'?'u':'b',m.content);
      });
      hist=data.hist.slice(-50);
      updateProfileBar();
      if(data.leadSent){
        leadSent=true;
        var inp=document.getElementById('aiIn');
        if(inp){inp.placeholder='Заявка отправлена ✓';inp.disabled=true;}
        var btn=document.getElementById('aiBtn');if(btn)btn.disabled=true;
      }
      var q=document.getElementById('aiQ');if(q)q.style.display='none';   // уже общались
      return true;
    }catch(_e){
      try{window.localStorage.removeItem(CHAT_STORE_KEY);}catch(_e2){/* no-op */}
      return false;
    }
  }

  // Сбросить диалог («Новый диалог»): чистим storage + ленту + state, заново
  // показываем приветствие и quick-кнопки. CSP-safe (вызывается по addEventListener).
  window.aiClearChat=function(){
    // ⛔ Оболочка может быть ещё не построена (вызов из кода, не по кнопке) —
    //    иначе дальше пришлось бы обращаться к несуществующим узлам.
    ensureShell();
    try{if(typeof window.localStorage!=='undefined')window.localStorage.removeItem(CHAT_STORE_KEY);}catch(_e){/* no-op */}
    hist=[];profile={};leadSent=false;
    if(pageCity)profile.city=pageCity;
    var body=document.getElementById('aiBody');if(body)body.textContent='';
    var bar=document.getElementById('aiPbar');if(bar){bar.textContent='';bar.classList.remove('show');}
    var lead=document.getElementById('aiLead');if(lead)lead.classList.remove('show');
    var inp=document.getElementById('aiIn');if(inp){inp.disabled=false;inp.placeholder='Задайте вопрос...';inp.value='';}
    var btn=document.getElementById('aiBtn');if(btn)btn.disabled=false;
    var q=document.getElementById('aiQ');if(q)q.style.display='';
    chatPainted=true;   // лента нарисована вручную — повторно её рисовать не надо
    addMsg('b',greetingText());
  };

  function updateProfileBar(){
    var bar=document.getElementById('aiPbar');
    var tags=[];
    if(profile.name)tags.push('👤 '+profile.name);
    var cityName = window.BroniPlaces ? window.BroniPlaces.name(profile.city) : null;
    if(cityName && profile.city==='spb')cityName='СПб'; // прежняя короткая подпись профиля
    if(cityName)tags.push('🏙 '+cityName);
    if(profile.rooms)tags.push('🛏 '+profile.rooms+'к');
    if(profile.budget)tags.push('💰 '+profile.budget);
    if(profile.mortgage_type)tags.push('🏦 '+profile.mortgage_type);
    if(profile.certificate)tags.push('📜 Сертификат');
    if(profile.phone)tags.push('📞 есть');

    if(tags.length>0){
      bar.textContent='';
      tags.forEach(function(t){var s=document.createElement('span');s.className='ai-ptag';s.textContent=t;bar.appendChild(s);});
      bar.classList.add('show');
    }
  }

  function showLeadSuccess(lead){
    leadSent=true;
    var el=document.getElementById('aiLead');
    var id=String(lead.booking_id||'').replace(/[<>"'&]/g,'');
    el.textContent='';var md=document.createElement('div');md.className='msg';md.textContent='\u2705 Заявка #'+id+' создана! Агент позвонит вам в ближайшее время.';el.appendChild(md);
    el.classList.add('show');
    // Disable input
    document.getElementById('aiIn').placeholder='Заявка отправлена ✓';
    document.getElementById('aiIn').disabled=true;
    document.getElementById('aiBtn').disabled=true;
  }

  // CSP: addEventListener вместо inline onclick/onkeydown.
  // ⛔ ЗДЕСЬ ОСТАЛСЯ ТОЛЬКО ПУЗЫРЬ. Он единственный приходит с сервера — у него
  //    нет текста, только эмодзи. Обработчики самой оболочки вешает bindShell()
  //    сразу после её постройки: до первого открытия вешать не на что.
  var fab=document.getElementById('aiFab');
  if(fab) fab.addEventListener('click',window.aiToggle);
  // Оболочка, пришедшая с сервера (старая разметка/сторонний шаблон), тоже должна
  // получить обработчики — иначе чат в таком окружении молча не отвечал бы.
  if(document.getElementById('aiBody')) bindShell();

  // ── В-15 (02.09.2026): авто-открытие через 5 с — ТОЛЬКО карточка ЖК, ТОЛЬКО человек ──
  // Отличаем человека дёшево: таймер взводится от ПЕРВОГО события взаимодействия
  // (scroll / касание / клавиша / движение мыши). Робот отрисовки событий не
  // порождает — окно ему не открывается, а текст под выдачу и так лежит в DOM
  // (#aiSeoLead). Закрыл чат один раз — sessionStorage-флаг, повторно само не
  // открывается. sessionStorage недоступен (приватный режим) → считаем «уже
  // закрывал» и не навязываемся: fail-closed.
  var AUTO_OPEN_MS=5000;
  (function(){
    if(!aiwRoot||aiwRoot.getAttribute('data-ai-card')!=='1')return;
    function autoOpenDone(){
      try{
        if(typeof window.sessionStorage==='undefined')return true;
        return window.sessionStorage.getItem('aiAutoOpenDone')==='1';
      }catch(_e){return true;}
    }
    if(autoOpenDone())return;
    var armed=false;
    var evs=['scroll','pointerdown','touchstart','keydown','mousemove'];
    function onFirstInteraction(){
      if(armed)return;
      armed=true;
      evs.forEach(function(ev){document.removeEventListener(ev,onFirstInteraction,true);});
      setTimeout(function(){
        // Человек мог успеть открыть (и закрыть) чат сам — не дёргаем.
        if(open||autoOpenDone())return;
        try{if(window.sessionStorage)window.sessionStorage.setItem('aiAutoOpenDone','1');}catch(_e){/* no-op */}
        window.aiToggle('auto');
      },AUTO_OPEN_MS);
    }
    evs.forEach(function(ev){document.addEventListener(ev,onFirstInteraction,{capture:true,passive:true});});
  })();
})();
